export type ChangelogEntryType = "feature" | "improvement" | "fix" | "other";

export type ChangelogEntry = {
  type: ChangelogEntryType;
  text: string;
};

export type ChangelogRelease = {
  version: string;
  /** ISO date (YYYY-MM-DD) — the date this version was cut. */
  date: string;
  entries: ChangelogEntry[];
};

/**
 * Generated + maintained by `scripts/release.mjs` — DO NOT hand-edit
 * individual releases' wording, since a future `pnpm run release` run
 * regenerates the newest entry from the LLM's own output, not from
 * whatever's here. New releases are PREPENDED (index 0 is always the
 * newest), matching this array's own display order on `/changelog`.
 */
export const CHANGELOG: ChangelogRelease[] = [
  {
    version: "0.3.0",
    date: "2026-07-10",
    entries: [
      { type: "feature", text: "Added an admin Notifications page for looking up any user and managing their notification channels and preferences, including bulk enable/disable." },
      { type: "improvement", text: "QA Automation run details now use real data end-to-end, with a redesigned video player, shareable links to specific tabs/tests, a verdict filter, and better loading/error states." },
      { type: "improvement", text: "The Recent Runs list on QA Automation now loads real data and scrolls correctly within its own panel." },
      { type: "feature", text: "You're now shown a clear sign-in screen if your session has expired, instead of parts of the app silently breaking." },
      { type: "fix", text: "Fixed a bug that could cause the QA run detail page to freeze or lag due to a rendering loop." },
      { type: "fix", text: "Cleaned up small display issues: a stray page title on the Slowest Tests page, a misaligned scroll shadow on Recent Runs, and redundant page headings across several pages." },
    ],
  },
  {
    version: "0.2.0",
    date: "2026-07-10",
    entries: [
      { type: "feature", text: "Added an admin notifications page to search users and bulk-manage their notification channels and preferences" },
      { type: "feature", text: "QA Automation run details now show real data, including verdict filters, a real video player, and shareable links to specific tests and tabs" },
      { type: "improvement", text: "Session expiration is now handled cleanly with a single sign-in screen instead of broken pages" },
      { type: "improvement", text: "Cleaned up page titles and layout across Notifications, Changelog, QA Automation, and Workflows pages" },
      { type: "fix", text: "Fixed a bug causing the QA run detail page to freeze from a rendering loop, plus various scroll and layout glitches" },
    ],
  },
  {
    version: "0.1.0",
    date: "2026-07-09",
    entries: [
      { type: "feature", text: "Added a QA Automation section with a dashboard, recent test runs, slowest tests, and highest failure rate views." },
      { type: "feature", text: "Added a Workflows section with a summary dashboard, run history with infinite scroll, and detailed run pages with timelines." },
      { type: "feature", text: "Added a changelog page to track what's new in the app." },
      { type: "improvement", text: "Improved navigation with working links, sidebar entries, and breadcrumbs across all pages." },
    ],
  },];
